import React, { Component } from 'react'
import Input from './../input'
import Radio from './../radio'
import { PROTOCOL } from './../../lib/helper'
import _ from 'underscore'

const FORMTYPE = { FTP: 1, TOKEN: 2 }

class DreamHostFormInputFields extends Component{
	constructor(props){
		super(props)
		this.state = { currentForm: this.props.fields["machine_token"] ? FORMTYPE.TOKEN : FORMTYPE.FTP }
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key){
		const { errors, fields } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	toggleForm(formType) {
		this.setState({currentForm: formType})
	}

	tokenForm() {
		return <div>
			<p className="bv-form-title fw-600 text-right">
				<a onClick={() => this.toggleForm(FORMTYPE.FTP)}>Manually Input Host Details</a>
			</p>
			<div className="row">
				<div className={this.getClassName('machine_token')}>
					<i className="mdi mdi-key"></i>
					<Input
						type="text"
						name="machine_token"
						title="Migration Token"
						placeholder="Eg. 6LU9ECHXP7UTMZ8V"
						classname=""
						value={this.fetchValue('machine_token')}
					/>
				</div>
			</div>
			<div className="row hide-field">
				<Input
					type="hidden"
					title=""
					name="protocol"
					placeholder=""
					classname=""
					value={PROTOCOL.SFTP}
				/>
			</div>
		</div>
	}

	ftpForm() {
		return <div>
			{/*<p className="bv-form-title fw-600 text-right">
				<a onClick={() => this.toggleForm(FORMTYPE.TOKEN)}>I have a Migration Token</a>
			</p>*/}
			<p className="bv-form-title text-left">Enter FTP Details of the new site that you want to migrate to</p>
			<div className="row">
				<div className={this.getClassName('newurl')}>
					<i className="mdi mdi-web"></i>
					<Input
						type="text"
						name="newurl"
						title="Destination Site URL"
						placeholder="Eg. www.google.com"
						classname=""
						value={this.fetchValue('newurl')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('address')}>
					<i className="mdi mdi-server"></i>
					<Input
						type="text"
						name="address"
						title="Destination Server FTP IP"
						placeholder="Eg. 127.0.0.1"
						classname=""
						value={this.fetchValue('address')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('type')}>
					<Radio
						name="type"
						title="FTP Type"
						items={['ftp', 'sftp']}
						value={this.fetchValue('type') || 'ftp'}
						widthClass="col-xs-4 col-md-4"
						iconClass="mdi mdi-clipboard-arrow-left"
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('username')}>
					<i className="mdi mdi-account"></i>
					<Input
						type="text"
						name="username"
						title="FTP Username"
						placeholder="Enter FTP username here"
						classname=""
						value={this.fetchValue('username')}
					/>
				</div>
			</div>
			<div className="row">
				<div className={this.getClassName('passwd')}>
					<i className="mdi mdi-lock"></i>
					<Input
						type="password"
						name="passwd"
						title="FTP Password"
						placeholder="Enter FTP password here"
						classname=""
						value={this.fetchValue('passwd')}
					/>
				</div>
			</div>
		</div>
	}

	render(){
		const { currentForm } = this.state
		return (
			<div>
				{this.ftpForm()}
				{/*currentForm === FORMTYPE.FTP ? this.ftpForm() : this.tokenForm()*/}
				<div className="row hide-field">
					<Input
						type="hidden"
						name="migrate"
						value="dreamhost"
						title=""
						placeholder=""
						classname=""
					/>
					<Input
						type="hidden"
						name="nameserver"
						value="ns1.dreamhost.com"
						title=""
						placeholder=""
						classname=""
					/>
				</div>
			</div>
		)
	}
}

export default DreamHostFormInputFields
